<div id="module-table-component" class="py-1.5">
  <p-table [resizableColumns]="true" columnResizeMode="expand"  #moduleTable [value]="modules()" [showLoader]="true" [loading]="isBusy()" dataKey="moduleId"
    [paginator]="true" [first]="tableFirst" [rows]="tableRows" (onPage)="onPageChange($event)" (onFilter)="onFilter($event)" [rowsPerPageOptions]="[10, 25, 50]"
    [currentPageReportTemplate]="'primeng.currentPageReportTemplate' | translate" [showCurrentPageReport]="true"
    class="md:text-base text-sm" [scrollable]="true"
    [globalFilterFields]="['name', 'abbreviation', 'claimString']"
    gateTableStateKey="moduleListTableState"
    >

    <ng-template #loadingIcon>
      <gate-loader [message]="'moduleLoadingMessage' | translate"></gate-loader>
    </ng-template>

    <ng-template #caption>
      <div class="grid lg:grid-cols-2 sm:grid-cols-3 grid-cols-1 md:text-base text-sm">
        <div class="col-span-1 my-auto md:mx-0 mb-3">
          <p class="font-['Apex_Rounded_Medium'] text-sm">{{ "kam.moduleManagement.tableTitle" | translate }}</p>
          </div>
        <div class="lg:col-span-1 sm:col-span-2 col-span-1 sm:text-right text-center">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            @if (hasActiveFilterOrSearch()) {
            <div class="col-span-1">
              <p-button [label]="'clearFilter' | translate" severity="danger"
                icon="pi pi-filter-slash" (click)="clearDataTable(moduleTable)"
                styleClass="md:w-auto w-full md:text-base text-sm" />
            </div>
            }
            <div class="col-span-1 sm:col-start-2">
              <div class="flex">
                <p-iconfield iconPosition="left" class="w-full">
                  <p-inputicon>
                    <i class="pi pi-search"></i>
                  </p-inputicon>
                  <input pInputText type="text" [placeholder]="'searchPlaceholder' | translate"
                    [ngModel]="searchString()" (ngModelChange)="onSearchChange($event, moduleTable)"
                    class="md:text-base text-sm w-full" />
                </p-iconfield>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #header let-columns>
      <tr>
        <th pResizableColumn pSortableColumn="abbreviation">
          {{ "kam.moduleManagement.abbreviation" | translate }}
          <p-sortIcon field="abbreviation"></p-sortIcon>
          <p-columnFilter type="text" field="abbreviation" display="menu" [showOperator]="false" [showMatchModes]="false"
            [showAddButton]="false" [hideOnClear]="true">
            <ng-template #filtericon let-hasFilter="hasFilter">
              <gate-table-filter-icon [hasFilter]="hasFilter" [table]="moduleTable" field="abbreviation" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="name">
          {{ "kam.moduleManagement.name" | translate }}
          <p-sortIcon field="name"></p-sortIcon>
          <p-columnFilter type="text" field="name" display="menu" [showOperator]="false" [showMatchModes]="false"
            [showAddButton]="false" [hideOnClear]="true">
            <ng-template #filtericon let-hasFilter="hasFilter">
              <gate-table-filter-icon [hasFilter]="hasFilter" [table]="moduleTable" field="name" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="claimString">
          {{ "kam.moduleManagement.claims" | translate }}
          <p-sortIcon field="claimString"></p-sortIcon>
          <p-columnFilter type="text" field="claimString" display="menu" [showOperator]="false" [showMatchModes]="false"
            [showAddButton]="false" [hideOnClear]="true">
            <ng-template #filtericon let-hasFilter="hasFilter">
              <gate-table-filter-icon [hasFilter]="hasFilter" [table]="moduleTable" field="claimString" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th pResizableColumn>
          {{ "kam.moduleManagement.isPublic" | translate }}
        </th>
        <th pResizableColumn pSortableColumn="isDefault">
          {{ "kam.moduleManagement.isDefault" | translate }}
          <p-sortIcon field="isDefault"></p-sortIcon>
        </th>
        <th width="70px" pResizableColumn pFrozenColumn alignFrozen="right"></th>
      </tr>
    </ng-template>

    <ng-template #body let-module let-columns="columns">
      <tr>
        <td>
          <span class="p-column-title">{{ "kam.moduleManagement.abbreviation" | translate }}</span>
          <span>{{ module.abbreviation }}</span>
        </td>
        <td>
          <span class="p-column-title">{{ "kam.moduleManagement.name" | translate }}</span>
            <span class="table-col-primary">{{ module.name }}</span>
        </td>
        <td>
          <span class="p-column-title">{{ "kam.moduleManagement.claims" | translate }}</span>
          <span>
            @if (module.editing) {
              <p-multiselect #moduleMultiSelect [options]="claims()" [(ngModel)]="module.tempClaims"
                placeholder="Select Claims" appendTo="body" optionLabel="translatedName" dataKey="roleId"
                panelStyleClass="gate-multiselect-panel--responsive"
                [showToggleAll]="true" [showHeader]="false"
                (onPanelHide)="onAccessUpdate(module, true)" class="w-full" autofocus="true"
                [disabled]="module.isDeleting">
                <ng-template #header>
                  <div class="flex flex-col gap-2 pt-2 pb-3 px-4 border-b border-[var(--border-color)]">
                    <p-iconfield iconPosition="left" class="w-full">
                      <p-inputicon>
                        <i class="pi pi-search"></i>
                      </p-inputicon>
                      <input pInputText type="text" [placeholder]="'searchPlaceholder' | translate"
                        (input)="moduleMultiSelect.onFilterInputChange($event)" class="w-full" />
                    </p-iconfield>
                    <div class="flex items-center justify-between gap-2">
                      <div class="flex items-center gap-2">
                        <p-checkbox [binary]="true" [ngModel]="moduleMultiSelect.allSelected()"
                          (onChange)="moduleMultiSelect.onToggleAll($event)" />
                        <span>{{ "kam.moduleManagement.selectAll" | translate }}</span>
                      </div>
                      <span class="claim-selected-count">
                        {{ "kam.moduleManagement.selectedCount" | translate: { count: module.tempClaims?.length || 0 } }}
                      </span>
                    </div>
                  </div>
                </ng-template>
                <ng-template #footer>
                  @if (!areClaimsEqual(module.claims, module.tempClaims)) {
                    <div class="flex align-items-center justify-center gap-2 p-3">
                      <a (click)="onAccessUpdate(module)" class="text-green-500">
                        <i class="pi pi-check"></i>
                      </a>
                      <a (click)="onAccessUpdate(module, true)" class="text-red-500">
                        <i class="pi pi-times"></i>
                      </a>
                    </div>
                  }
                </ng-template>
              </p-multiselect>
            } @else {
              @if (module.isClaimsUpdating) {
              <span class="flex w-full min-w-0 items-center gap-2 text-gray-500 dark:text-white">
                <i class="pi pi-spinner pi-spin shrink-0"></i>
                <span class="min-w-0 flex-1 truncate" [title]="module.claimString">
                  {{ module.claimString }}
                </span>
              </span>
              } @else {
              <button type="button"
                  class="flex w-full min-w-0 items-center gap-2 border-0 bg-transparent p-0 text-left text-inherit"
                  (click)="enableEditing(module)">
                  @if (module.claims?.length > 0) {
                  <span class="min-w-0 flex-1 truncate" [title]="module.claimString">
                    {{ module.claimString }}
                  </span>
                  } @else {
                  <span class="min-w-0 flex-1 truncate text-gray-500 dark:text-white">
                    {{ "kam.moduleManagement.noModulesAssigned" | translate }}
                  </span>
                  }
                  <i class="pi pi-angle-down shrink-0 text-sm text-gray-500 dark:text-white"></i>
                </button>
              }
            }
          </span>
        </td>
        <td>
          <span class="p-column-title">{{ "kam.moduleManagement.isPublic" | translate }}</span>
          <span class="flex justify-center">
            @if(module.isPublicLoading){
              <i class="pi pi-spinner pi-spin"></i>
            }@else {
              <p-toggleswitch [(ngModel)]="module.isTempPublic" [readonly]="module.isDeleting" (ngModelChange)="togglePublic(module)" onLabel="Yes" offLabel="No" class="w-36">
                <ng-template #handle let-checked="checked">
                    <i [ngClass]="['!text-xs', 'pi', checked ? 'pi-check' : 'pi-times']"></i>
                </ng-template>
              </p-toggleswitch>
            }
          </span>
        </td>
        <td>
          <span class="p-column-title">{{ "kam.moduleManagement.isDefault" | translate }}</span>
          <span class="flex justify-center">
            @if(module.isDefaultLoading){
              <i class="pi pi-spinner pi-spin"></i>
            }@else {
            <p-toggleswitch [(ngModel)]="module.isTempDefault" [readonly]="module.isDeleting" (ngModelChange)="toggleDefault(module)" onLabel="Yes" offLabel="No" styleClass="w-36">
                <ng-template #handle let-checked="checked">
                    <i [ngClass]="['!text-xs', 'pi', checked ? 'pi-check' : 'pi-times']"></i>
                </ng-template>
            </p-toggleswitch>
          }
          </span>
        </td>

        <td width="70px" class="action-td" pFrozenColumn alignFrozen="right">
          <div class="flex items-center justify-end gap-2">
            <p-button size="small" styleClass="btn-impersonate !h-[28px] w-full"
              [loading]="module.isDeleting"
              [disabled]="module.isDeleting"
              (onClick)="confirmDelete(module)">{{ "deleteButton" | translate}}</p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr class="emptymessage">
        <td colspan="6">
          <div class="text-center">
            <i class="pi pi-exclamation-triangle text-yellow-500" style="font-size: 2rem"></i>
            <p>{{ "kam.moduleManagement.noRecordsFound" | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog (onHide)="onHideDialog()" [message]="'kam.moduleManagement.confirmDelete' | translate"
  [header]="'kam.moduleManagement.confirmDeleteHeader' | translate" [acceptLabel]="'yes' | translate"
  [rejectLabel]="'cancelButton' | translate" rejectButtonStyleClass="p-button-secondary"></p-confirmDialog>
